import { useTranslation } from "react-i18next";

export function MobileAppUpdate({
  openAppStore,
}: {
  openAppStore: () => void;
  error?: Error;
}) {
  const { t } = useTranslation();
  const APP_NAME = t("newUpdateMobile.appName");
  const APP_LOGO = "/logos/favicon.png"; // Make sure this path is correct in your public directory

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-6 py-10 text-center">
      {/* App Logo */}
      <img
        src={APP_LOGO}
        alt={`${APP_NAME} Logo`}
        className="mb-4 h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24 lg:h-28 lg:w-28 object-contain"
      />

      {/* App Name */}
      <h2 className="text-xl font-semibold text-gray-800  sm:text-2xl md:text-3xl lg:text-4xl mb-10">
        {APP_NAME}
      </h2>

      {/* Heading */}
      <h1 className="text-sidebar-600 mb-3 text-2xl font-bold sm:text-3xl md:text-4xl lg:text-5xl">
        {t("newUpdateMobile.newUpdate")}
      </h1>

      {/* Description */}
      <p className="mb-6 max-w-md text-lg text-gray-600 sm:text-lg md:text-xl lg:text-2xl">
        {t("newUpdateMobile.description")}
      </p>

      {/* Button */}
      <button
        onClick={openAppStore}
        className="rounded-md bg-sidebar px-5 py-3 text-base font-semibold text-skyblue transition duration-300 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-sidebar focus:ring-offset-2 sm:text-lg"
      >
        {t("newUpdateMobile.UpdateNow")}
      </button>
    </div>
  );
}
